import { Box, type BoxProps } from "@mui/material";
import { useAppPathname } from "@/routing/navigation";
import { PAGE_MAX_WIDTH } from "@/providers/DrawerProvider";
import getPageContentContainer from "../PromoBanner/pageContentContainer";

/**
 * The page's content column, and inside it a box as wide as this page's
 * content container and aligned with it, as `PromoBanner` is.
 */
export const PageFrame = ({ children, ...props }: BoxProps) => {
  const pageContainer = getPageContentContainer(useAppPathname());

  return (
    <Box width="100%" maxWidth={PAGE_MAX_WIDTH} mx="auto" px={3} {...props}>
      <Box
        sx={
          pageContainer && {
            maxWidth: pageContainer.maxWidth,
            mx: pageContainer.centered ? "auto" : 0,
          }
        }
      >
        {children}
      </Box>
    </Box>
  );
};
